


















import { deleteFile, getCourseFilesById } from "@/api/file.api";
import { mapFields } from "vuex-map-fields";
import UploadCourseFileDialog from "@/components/course/new/files/UploadCourseFileDialog.vue";
import CourseSection from "@/components/course/CourseSection.vue";
import { defineComponent } from "@vue/composition-api";

interface File {
  id: string;
  originalFileName: string;
  description: string;
  category: any;
  mimeType: string;
}

interface ComponentData {
  files: File[];
}

export default defineComponent({
  name: "Files",
  components: { CourseSection },
  data(): ComponentData {
    return {
      files: [],
    };
  },
  methods: {
    deleteFile(fileId: any) {
      this.files = this.files.filter((file) => file.id != fileId);
      deleteFile(fileId);
    },
    openUploadDialog() {
      (this as any)
        .$dialog({
          component: UploadCourseFileDialog,
          parent: this,
          id: this.$route.params.id,
          category: "økonomi",
          entity: "course",
        })
        .onOk((files: File[]) => (this.files = [...(this.files || []), ...files]));
    },
  },
  computed: {
    ...mapFields("execution", ["executionPlan.info.groupIdRequired"]),
  },
  async mounted() {
    const res = await getCourseFilesById((this as any).$route.params.id);
    for (const file of res.data) {
      if (file.category === "økonomi") {
        this.files.push({
          id: file.id,
          originalFileName: file.originalFileName,
          description: file.description,
          category: file.category,
          mimeType: file.mimeType,
        });
      }
    }
  },
});
